var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteEye = function SvgWhiteEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M1.2 7.784a1.634 1.634 0 0 1 0-1.569A10.019 10.019 0 0 1 10 1c3.797 0 7.1 2.108 8.8 5.216.267.489.267 1.08 0 1.569A10.019 10.019 0 0 1 10 13c-3.797 0-7.1-2.108-8.8-5.216Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M7 7a3 3 0 1 0 3-3"
  })));
};
export default SvgWhiteEye;